module.exports = __webpack_public_path__ + "img/symbol_16.f8e4bb69.png";